
import {IControlStyle, IFilter, IFontSize, IMinMax, IMultiSelect, IPlaceholder, IRows, IShowHorizontal, ISourceDatasetDinamico, ITooltip } from '../../services/form-builder/form.interface';
import { BaseControl, Options } from './form-base-controls';
import { CalendarControl, CheckboxControl, DropdownControl, FileUploadControl, InputMaskControl, InputNumberControl, InputTextareaControl, InputTextControl, LabelControl, SubFormularioControl } from './form-controls';

export class TypeChecker {

  //#region Control Checkers
  static hasOptions(control: any): control is Options<any> {
    return control instanceof Options;
  }

  static isInputText(control: any): control is InputTextControl {
    return control instanceof InputTextControl;
  }

  static isInputNumber(control: any): control is InputNumberControl {
    return control instanceof InputNumberControl;
  }

  static isInputMask(control: any): control is InputMaskControl {
    return control instanceof InputMaskControl
  }

  static isCalendar(control: any): control is CalendarControl {
    return control instanceof CalendarControl;
  }

  static isDropdown(control: any): control is DropdownControl {
    return control instanceof DropdownControl;
  }

  static isCheckbox(control: any): control is CheckboxControl {
    return control instanceof CheckboxControl;
  }

  static isFileUpload(control: any): control is FileUploadControl {
    return control instanceof FileUploadControl;
  }

  static isLabel(control: any): control is LabelControl {
    return control instanceof LabelControl;
  }

  static isTextArea(control: any): control is InputTextareaControl {
    return control instanceof InputTextareaControl;
  }

  static isSubFormulario(control: any): control is SubFormularioControl {
    return control instanceof SubFormularioControl;
  }
  //#endregion Control Checkers

  //#region Interface Checkers
  static hasControlStyle(control: any): control is IControlStyle {
    return 'startOnNewLine' in control && 'widthSmallScreen' in control && 'widthMediumScreen' in control && 'widthLargeScreen' in control  && 'widthLargerScreen' in control;
  }

  static hasPlaceholder(control: any): control is IPlaceholder {
    return control && 'placeholder' in control;
  }

  static hasFilter(control: any): control is IFilter{
    return control && 'filter' in control;
  }

  static hasShowHorizontal(control: any): control is IShowHorizontal {
    return control && 'showHorizontal' in control;
  }

  static hasMultiSelect(control: any): control is IMultiSelect {
    return control && 'multiSelect' in control;
  }

  static hasFontSize(control: any): control is IFontSize {
    return control && 'fontSize' in control;
  }

  static hasRows(control: any): control is IRows {
    return control && 'rows' in control;
  }

  static hasMinMax(control: any): control is IMinMax {
    return 'min' in control && 'max' in control;
  }

  static hasProperty(obj: BaseControl<any>, key: string): key is keyof BaseControl<any> {
    return key in obj;
  }

  static isSourceDatasetDinamico(control: any): control is ISourceDatasetDinamico {
    return 'tablaConsulta' in control && 'columnName' in control && 'columnValue' in control;
  }

  static hasTooltip(control: any): control is ITooltip {
    return 'tooltip' in control;
  }

  static hasReadonly(control: any): control is {readonly: boolean} {
    return 'readonly' in control;
  }
  //#endregion Interface Checkers
}
